/**
 * ReadOnlyField · txn kit (presentation only)
 * One consistent visual for SYSTEM-DERIVED / read-only values so operators can
 * instantly tell them apart from editable inputs: dashed border + muted fill
 * (vs the solid-border, solid-fill editable controls). No logic.
 */
import React from "react";

const TONES = {
  default: "text-[var(--fg-0)]",
  muted: "text-[var(--fg-1)]",
  accent: "text-[var(--accent)]",
  emerald: "text-emerald-400",
  amber: "text-amber-400",
  rose: "text-rose-400",
  sky: "text-sky-400",
};

export default function ReadOnlyField({
  value,
  placeholder = "—",
  mono = false,
  tone = "default",
  icon = null,
  title,
  className = "",
  testId,
}) {
  const empty = value === null || value === undefined || value === "";
  return (
    <div
      data-testid={testId}
      title={title}
      className={`h-9 px-3 flex items-center gap-2 bg-[var(--bg-2)] border border-dashed border-[var(--border)] rounded-sm text-sm ${
        empty ? "text-[var(--fg-3)]" : TONES[tone] || TONES.default
      } ${mono ? "font-mono" : ""} ${className}`}
    >
      {icon}
      <span className="truncate">{empty ? placeholder : value}</span>
    </div>
  );
}
